module.exports = __webpack_public_path__ + "img/NL2698220.cb9184cd.png";